/**
 * CardsPage — placeholder for the Shopping-mode loyalty/discount Cards wallet.
 *
 * The shell (T12.1.5.1.1) places the `/deals`↔`/cards` middle nav slot, which
 * flips to "Cards" in Shopping mode. The wallet feature itself is owned by
 * T12.1.9; until then the slot renders an honest "coming soon" surface.
 *
 * The Cards wallet has no standalone route in the table — the bottom nav's
 * middle slot in Shopping mode points here. It is reachable only via that slot.
 */

import { ComingSoon } from '../../components';

export function CardsPage(): JSX.Element {
  return (
    <ComingSoon icon="💳" title="Your cards" data-testid="cards-page">
      Your loyalty and discount cards, ready to scan at the till. We&apos;re
      building the wallet next.
    </ComingSoon>
  );
}
